/* Fusya Stitch theme – global behaviour */
(function () {
  'use strict';
  var F = window.Fusya || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function waLink(text) {
    return 'https://wa.me/' + (F.whatsapp || '') + (text ? '?text=' + encodeURIComponent(text) : '');
  }
  F.waLink = waLink;

  function money(cents) {
    var n = (cents / 100).toFixed(2).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return n[0] + ',' + n[1];
  }
  F.money = money;

  /* ---------------------------------------------------------------- lock scroll */
  function lock(on) { document.documentElement.classList.toggle('overflow-hidden', !!on); }

  /* ---------------------------------------------------------------- cart */
  function setCount(n) {
    F.cartCount = n;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); });
  }

  function drawer() { return document.getElementById('sx-cart-drawer'); }

  function openCart() {
    var d = drawer(); if (!d) { window.location.href = F.routes.cart; return; }
    d.removeAttribute('hidden'); lock(true);
  }
  function closeCart() { var d = drawer(); if (d) d.setAttribute('hidden', ''); lock(false); }
  F.openCart = openCart; F.closeCart = closeCart;

  function refreshCart(open) {
    return fetch(F.routes.root + '?sections=sx-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['sx-cart-drawer'];
        var wrap = document.getElementById('shopify-section-sx-cart-drawer');
        if (html && wrap) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var fresh = tmp.querySelector('#shopify-section-sx-cart-drawer') || tmp;
          wrap.innerHTML = fresh.innerHTML;
        }
        return fetch(F.routes.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        setCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('fusya:cart', { detail: cart }));
        if (open) openCart();
        return cart;
      });
  }
  F.refreshCart = refreshCart;

  function addToCart(body, btn) {
    var original = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.classList.add('opacity-70'); }
    return fetch(F.routes.cartAdd + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: body instanceof FormData ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body instanceof FormData ? body : JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(true); })
      .catch(function (err) {
        alert((err && (err.description || err.message)) || 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.');
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('opacity-70'); if (original !== null) btn.innerHTML = original; } });
  }
  F.addToCart = addToCart;

  function changeLine(key, qty) {
    return fetch(F.routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () {
      if (document.body.dataset.template === 'cart' || /\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      return refreshCart(true);
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-product-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]:not([name="checkout"])');
    addToCart(new FormData(form), btn);
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-add-variant],[data-cart-qty],[data-cart-close],[data-cart-open],[data-cart-backdrop],[data-wishlist-toggle],[data-open-menu],[data-menu-close],[data-open-search],[data-search-close],[data-cookie-accept]') : null;
    if (!t) return;
    if (t.hasAttribute('data-add-variant')) {
      e.preventDefault();
      addToCart({ items: [{ id: Number(t.getAttribute('data-add-variant')), quantity: Number(t.getAttribute('data-qty') || 1) }] }, t);
    } else if (t.hasAttribute('data-cart-qty')) {
      e.preventDefault(); changeLine(t.getAttribute('data-cart-qty'), Number(t.getAttribute('data-qty')));
    } else if (t.hasAttribute('data-cart-close')) {
      e.preventDefault(); closeCart();
    } else if (t.hasAttribute('data-cart-open')) {
      e.preventDefault(); openCart();
    } else if (t.hasAttribute('data-cart-backdrop')) {
      if (e.target === t) closeCart();
    } else if (t.hasAttribute('data-wishlist-toggle')) {
      e.preventDefault(); toggleWish(t.getAttribute('data-wishlist-toggle'));
    } else if (t.hasAttribute('data-open-menu')) {
      e.preventDefault(); var m = document.getElementById('sx-menu-drawer'); if (m) { m.removeAttribute('hidden'); lock(true); }
    } else if (t.hasAttribute('data-menu-close')) {
      if (t.hasAttribute('data-backdrop') && e.target !== t) return;
      e.preventDefault(); var m2 = document.getElementById('sx-menu-drawer'); if (m2) { m2.setAttribute('hidden', ''); lock(false); }
    } else if (t.hasAttribute('data-open-search')) {
      e.preventDefault(); openSearch();
    } else if (t.hasAttribute('data-search-close')) {
      if (t.hasAttribute('data-backdrop') && e.target !== t) return;
      e.preventDefault(); closeSearch();
    } else if (t.hasAttribute('data-cookie-accept')) {
      e.preventDefault(); try { localStorage.setItem('fusyaCookie', '1'); } catch (x) {}
      var cb = $('[data-cookie-banner]'); if (cb) cb.setAttribute('hidden', '');
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeSearch(); var m = document.getElementById('sx-menu-drawer'); if (m) m.setAttribute('hidden', ''); lock(false); } });

  /* ---------------------------------------------------------------- wishlist */
  function getWish() { try { return JSON.parse(localStorage.getItem('fusyaWishlist') || '[]'); } catch (x) { return []; } }
  function setWish(list) { try { localStorage.setItem('fusyaWishlist', JSON.stringify(list)); } catch (x) {} paintWish(); document.dispatchEvent(new CustomEvent('fusya:wishlist', { detail: list })); }
  function toggleWish(handle) {
    var l = getWish(); var i = l.indexOf(handle);
    if (i > -1) l.splice(i, 1); else l.unshift(handle);
    setWish(l);
  }
  function paintWish() {
    var l = getWish();
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = l.length; if (l.length) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); });
    $$('[data-wishlist-toggle]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-wishlist-toggle')) > -1;
      b.classList.toggle('text-primary', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var ic = b.querySelector('.material-symbols-outlined');
      if (ic) ic.style.fontVariationSettings = on ? "'FILL' 1" : '';
    });
  }
  F.getWish = getWish; F.setWish = setWish; F.toggleWish = toggleWish;

  /* ---------------------------------------------------------------- search overlay + predictive */
  function openSearch() {
    var s = document.getElementById('sx-search-overlay'); if (!s) { location.href = F.routes.search; return; }
    s.removeAttribute('hidden'); lock(true);
    var i = s.querySelector('input[name="q"]'); if (i) setTimeout(function () { i.focus(); }, 60);
  }
  function closeSearch() { var s = document.getElementById('sx-search-overlay'); if (s) s.setAttribute('hidden', ''); lock(false); }
  F.openSearch = openSearch;

  var searchTimer;
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-predictive-input]')) return;
    clearTimeout(searchTimer);
    var q = input.value.trim();
    var box = document.querySelector(input.getAttribute('data-predictive-input'));
    if (!box) return;
    if (q.length < 2) { box.innerHTML = box.getAttribute('data-empty') || ''; return; }
    searchTimer = setTimeout(function () {
      fetch(F.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=3', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          var tpl = document.getElementById(box.getAttribute('data-template'));
          if (!items.length) { box.innerHTML = '<p class="font-body-sm text-body-sm text-on-surface-variant p-space-md">“' + q.replace(/</g, '&lt;') + '” için sonuç bulunamadı.</p>'; return; }
          box.innerHTML = items.map(function (p) {
            var price = Math.round(parseFloat(p.price) * 100);
            var hav = Math.round(price * (100 - (F.havalePercent || 0)) / 100);
            return (tpl ? tpl.innerHTML : '<a href="{url}">{title}</a>')
              .replace(/\{url\}/g, p.url).replace(/\{title\}/g, p.title)
              .replace(/\{image\}/g, p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '')
              .replace(/\{type\}/g, p.type || '').replace(/\{vendor\}/g, p.vendor || '')
              .replace(/\{price\}/g, money(price)).replace(/\{havale\}/g, money(hav));
          }).join('');
        }).catch(function () {});
    }, 220);
  });
  document.addEventListener('focusin', function (e) {
    if (e.target.matches && e.target.matches('[data-open-search-input]') && window.innerWidth >= 1024) { e.target.blur(); openSearch(); }
  });

  /* ---------------------------------------------------------------- assistant (honest WhatsApp concierge) */
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function chat() { return document.getElementById('chat-messages'); }
  function bubbleUser(text) {
    var c = chat(); if (!c) return;
    var d = document.createElement('div'); d.className = 'flex justify-end';
    d.innerHTML = '<div class="bg-gradient-to-r from-[#9b0044] to-[#EC008C] text-white p-3 rounded-2xl rounded-tr-sm text-xs sm:text-sm max-w-[85%] shadow-sm leading-relaxed">' + esc(text) + '</div>';
    c.appendChild(d); c.scrollTop = c.scrollHeight;
  }
  function bubbleBot(html) {
    var c = chat(); if (!c) return;
    var d = document.createElement('div'); d.className = 'flex items-start gap-2.5 max-w-[92%]';
    d.innerHTML = '<div class="w-8 h-8 rounded-full bg-[#480c29] text-[#ffd9df] flex items-center justify-center text-xs font-bold shrink-0 mt-0.5 ring-1 ring-[#EC008C]/40">F</div><div class="bg-white p-3.5 rounded-2xl rounded-tl-sm text-xs sm:text-sm text-on-surface shadow-sm border border-outline-variant/30 space-y-2 leading-relaxed">' + html + '</div>';
    c.appendChild(d); c.scrollTop = c.scrollHeight;
  }
  function reply(q) {
    var t = q.toLocaleLowerCase('tr');
    var btn = '<a class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-[#2a0616] text-[#ffd9df] hover:bg-primary hover:text-white transition-all text-xs font-bold" target="_blank" rel="noopener" href="' + waLink(q) + '"><span class="material-symbols-outlined text-[14px]">chat</span>WhatsApp\'ta Sor</a>';
    if (/adres|mağaza|magaza|meram|showroom|konum|nerede|deneyebilir/.test(t)) return '<p><strong>Fusya Fashion Butik:</strong><br>' + esc(F.address || '') + '</p><p class="text-[12px] text-on-surface-variant">Ziyaret öncesi WhatsApp\'tan haber verebilirsiniz.</p>' + btn;
    if (/havale|eft|fast|iban|indirim/.test(t)) return '<p>Havale / EFT ile ödemelerde <strong>%' + (F.havalePercent || 0) + ' indirim</strong> uygulanır. Siparişinizi oluşturduktan sonra IBAN bilgisi ve dekont için WhatsApp hattımızdan yardımcı oluyoruz.</p>' + btn;
    if (/beden|ölçü|olcu|kalıp|kalip/.test(t)) return '<p>Boy, kilo ve genelde giydiğiniz bedeni yazarsanız stil danışmanımız size en uygun bedeni önerir.</p>' + btn;
    if (/kargo|teslim/.test(t)) return '<p>Siparişler sigortalı kargo ile gönderilir. Kargo ücreti ödeme adımında hesaplanır.</p>' + btn;
    if (/stok|var mı|var mi/.test(t)) return '<p>Güncel stok durumu ürün sayfasında görünür. Kesin bilgi ve ayırtma için mesajınızı stil danışmanımıza iletin.</p>' + btn;
    return '<p>Sorunuzu stil danışmanımıza WhatsApp üzerinden iletebilirsiniz; en kısa sürede dönüş yapılır.</p>' + btn;
  }
  window.toggleAssistantModal = function (show) {
    var m = document.getElementById('fusya-assistant-modal'); if (!m) { window.open(waLink(F.whatsappMessage), '_blank'); return; }
    if (show) { m.classList.remove('hidden'); setTimeout(function () { var i = document.getElementById('assistant-input'); if (i) i.focus(); }, 150); }
    else m.classList.add('hidden');
  };
  window.askAssistant = function (q) { window.toggleAssistantModal(true); bubbleUser(q); setTimeout(function () { bubbleBot(reply(q)); }, 350); };
  window.sendAssistantMessage = function () { var i = document.getElementById('assistant-input'); if (!i || !i.value.trim()) return; var q = i.value.trim(); i.value = ''; window.askAssistant(q); };
  window.quickStockCheck = function () { var i = document.getElementById('hero-stock-input'); var v = i ? i.value.trim() : ''; window.askAssistant(v ? 'Stok durumu: ' + v : 'Stok durumu hakkında bilgi almak istiyorum'); };
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target && e.target.id === 'assistant-input') { e.preventDefault(); window.sendAssistantMessage(); } });

  /* ---------------------------------------------------------------- filters & sorting */
  function submitFilters(form) {
    $$('input,select', form).forEach(function (i) { if (i.name && i.value === '' ) i.disabled = true; });
    form.submit();
  }
  var filterTimer;
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches && el.matches('[data-sort-select]')) {
      var u = new URL(location.href); u.searchParams.set('sort_by', el.value); u.searchParams.delete('page'); location.href = u.toString(); return;
    }
    var form = el.closest && el.closest('[data-filter-form]');
    if (!form || form.hasAttribute('data-no-autosubmit')) return;
    clearTimeout(filterTimer);
    filterTimer = setTimeout(function () { submitFilters(form); }, el.type === 'number' || el.type === 'range' ? 500 : 50);
  });
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('[data-price-range]')) return;
    var form = el.closest('form'); if (!form) return;
    var mx = form.querySelector('[data-price-max]'); if (mx) mx.value = el.value;
    var lb = form.querySelector('[data-price-label]'); if (lb) lb.textContent = '₺' + Number(el.value).toLocaleString('tr-TR');
  });
  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('[data-filter-form]')) { e.preventDefault(); submitFilters(e.target); }
  });
  function sheet(open) {
    var s = document.getElementById('sx-filter-sheet'); if (!s) return;
    var p = s.querySelector('[data-filter-panel]');
    if (open) { s.classList.remove('hidden'); lock(true); requestAnimationFrame(function () { p.classList.remove('translate-y-full'); }); }
    else { p.classList.add('translate-y-full'); lock(false); setTimeout(function () { s.classList.add('hidden'); }, 280); }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-open-filter],[data-filter-close],[data-grid-cols]') : null;
    if (!t) return;
    if (t.hasAttribute('data-open-filter')) { e.preventDefault(); sheet(true); }
    else if (t.hasAttribute('data-filter-close')) { e.preventDefault(); sheet(false); }
  });

  /* ---------------------------------------------------------------- product page */
  var productData = null;
  try { var pj = document.getElementById('sx-product-json'); if (pj) productData = JSON.parse(pj.textContent); } catch (x) {}
  function tl(cents) { return money(cents); }
  function applyVariant(v, sourceForm) {
    if (!v) return;
    var hp = 100 - (F.havalePercent || 0);
    $$('[data-sx-variant-form]').forEach(function (f) {
      var idIn = f.querySelector('[data-sx-variant-id]'); if (idIn) idIn.value = v.id;
      v.options.forEach(function (val, i) {
        $$('[data-sx-option="' + i + '"]', f).forEach(function (r) { r.checked = (r.value === val); });
      });
    });
    v.options.forEach(function (val, i) { $$('[data-sx-option-label="' + i + '"]').forEach(function (el) { el.textContent = val; }); });
    var hv = Math.round(v.price * hp / 100);
    $$('[data-sx-price]').forEach(function (el) { el.textContent = el.textContent.trim().charAt(0) === '₺' ? '₺' + tl(v.price) : tl(v.price) + ' TL'; });
    $$('[data-sx-havale]').forEach(function (el) { el.textContent = el.textContent.trim().charAt(0) === '₺' ? '₺' + tl(hv) : tl(hv) + ' TL'; });
    $$('[data-sx-compare]').forEach(function (el) {
      if (v.compare_at_price && v.compare_at_price > v.price) { el.hidden = false; el.textContent = el.textContent.trim().charAt(0) === '₺' ? '₺' + tl(v.compare_at_price) : tl(v.compare_at_price) + ' TL'; }
      else el.hidden = true;
    });
    $$('[data-sx-sku]').forEach(function (el) { el.hidden = !v.sku; var s = el.querySelector('span'); if (s) s.textContent = v.sku || ''; });
    var stock = v.available ? 'Stokta' : 'Tükendi';
    if (v.available && v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= (F.lowStock || 5)) stock = 'Son ' + v.inventory_quantity + ' Adet Kaldı';
    $$('[data-sx-stock]').forEach(function (el) { el.textContent = stock; });
    $$('[data-sx-atc]').forEach(function (b) {
      b.disabled = !v.available;
      var l = b.querySelector('[data-sx-atc-label]');
      if (l) l.textContent = v.available ? (l.closest('.sx-mobile') ? 'Sepete Ekle • ₺' + tl(v.price) : 'Sepete Ekle • ' + tl(v.price) + ' TL') : 'Tükendi';
    });
    if (v.featured_media && v.featured_media.preview_image) {
      var src = v.featured_media.preview_image.src;
      var main = $('[data-sx-main-img]'); if (main) main.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
    }
    if (window.history && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
  }
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!productData || !r.matches || !r.matches('[data-sx-option]')) return;
    var f = r.closest('[data-sx-variant-form]');
    var sel = [];
    $$('[data-sx-option]:checked', f).forEach(function (c) { sel[Number(c.getAttribute('data-sx-option'))] = c.value; });
    var v = productData.variants.filter(function (x) { return x.options.every(function (o, i) { return sel[i] === undefined || sel[i] === o; }); })[0];
    if (!v) { $$('[data-sx-atc]').forEach(function (b) { b.disabled = true; var l = b.querySelector('[data-sx-atc-label]'); if (l) l.textContent = 'Bu kombinasyon yok'; }); return; }
    applyVariant(v, f);
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-sx-thumb],[data-sx-tab],[data-sx-modal-open],[data-sx-modal-close],[data-sx-copy]') : null;
    if (!t) { var m = e.target.closest && e.target.closest('[data-sx-modal]'); if (m && e.target === m) m.classList.add('hidden'); return; }
    if (t.hasAttribute('data-sx-thumb')) {
      var main = $('[data-sx-main-img]'); if (main) main.src = t.getAttribute('data-sx-thumb');
      var z = $('[data-sx-zoom]'); if (z && t.getAttribute('data-sx-zoom-src')) z.href = t.getAttribute('data-sx-zoom-src');
      $$('[data-sx-thumb]').forEach(function (b) { b.classList.toggle('ring-2', b === t); b.classList.toggle('ring-primary', b === t); });
    } else if (t.hasAttribute('data-sx-tab')) {
      var n = t.getAttribute('data-sx-tab'), wrap = t.closest('[data-sx-tabs]');
      $$('[data-sx-tab]', wrap).forEach(function (b) { var on = b === t; b.classList.toggle('text-primary', on); b.classList.toggle('bg-primary-fixed/50', on); b.classList.toggle('font-bold', on); b.classList.toggle('text-on-surface-variant', !on); });
      $$('[data-sx-pane]', wrap).forEach(function (p) { p.classList.toggle('hidden', p.getAttribute('data-sx-pane') !== n); });
    } else if (t.hasAttribute('data-sx-modal-open')) {
      e.preventDefault(); var md = document.getElementById(t.getAttribute('data-sx-modal-open')); if (md) md.classList.remove('hidden');
    } else if (t.hasAttribute('data-sx-modal-close')) {
      e.preventDefault(); var mc = t.closest('[data-sx-modal]'); if (mc) mc.classList.add('hidden');
    } else if (t.hasAttribute('data-sx-copy')) {
      e.preventDefault(); var val = t.getAttribute('data-sx-copy');
      try { navigator.clipboard.writeText(val).then(function () { t.classList.add('text-emerald-600'); setTimeout(function () { t.classList.remove('text-emerald-600'); }, 1500); }); } catch (x) { window.prompt('IBAN', val); }
    }
  });
  document.addEventListener('scroll', function (e) {
    var s = e.target; if (!s.matches || !s.matches('[data-sx-swiper]')) return;
    var i = Math.round(s.scrollLeft / s.clientWidth);
    var dots = s.parentElement.querySelector('[data-sx-dots]'); if (!dots) return;
    $$('span', dots).forEach(function (d, k) { d.classList.toggle('bg-surface-bright', k === i); d.classList.toggle('bg-surface-bright/40', k !== i); });
  }, true);

  /* ---------------------------------------------------------------- cart page */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('#sx-cart-form')) return;
    $$('textarea[name="note"]', f).forEach(function (t) { if (t.offsetParent === null) t.disabled = true; });
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-sx-coupon-apply]') : null;
    if (!b) return;
    var wrap = b.parentElement, inp = wrap.querySelector('[data-sx-coupon]');
    var code = inp && inp.value.trim();
    if (!code) { if (inp) inp.focus(); return; }
    location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(F.routes.cart);
  });
  document.addEventListener('change', function (e) {
    var r = e.target; if (!r.matches || !r.matches('[data-sx-pay]')) return;
    var box = r.closest('[data-sx-paybox]') || document;
    var key = r.value === 'havale' ? 'data-hv' : 'data-card';
    $$('[data-sx-pay-total],[data-sx-pay-note]', box).forEach(function (el) { el.textContent = el.getAttribute(key); });
    $$('[data-sx-pay]', box).forEach(function (x) { var l = x.closest('label'); if (l) { l.classList.toggle('bg-primary-fixed/20', x.checked); l.classList.toggle('bg-surface-container-low', !x.checked); } });
  });

  /* ---------------------------------------------------------------- wishlist page */
  function renderWishPage() {
    var items = $$('[data-sx-wish-item]'); if (!items.length && !$('[data-sx-wish-empty]')) return;
    var list = getWish();
    var hp = 100 - (F.havalePercent || 0);
    ['.sx-desktop', '.sx-mobile'].forEach(function (scope) {
      var root = $(scope); if (!root) return;
      var its = $$('[data-sx-wish-item]', root), shown = [], total = 0;
      its.forEach(function (el) {
        var on = list.indexOf(el.getAttribute('data-sx-wish-item')) > -1;
        el.hidden = !on;
        if (on) { shown.push(el); if (el.getAttribute('data-sx-available') === 'true') total += Number(el.getAttribute('data-price') || 0); }
      });
      // keep the wishlist order
      shown.sort(function (a, b) { return list.indexOf(a.getAttribute('data-sx-wish-item')) - list.indexOf(b.getAttribute('data-sx-wish-item')); })
        .forEach(function (el) { el.parentNode.appendChild(el); });
      var n = shown.length;
      $$('[data-sx-wish-count-label]', root).forEach(function (el) { el.textContent = el.textContent.charAt(0) === '(' ? '(' + n + ' Parça)' : n + ' Parça Seçildi'; });
      $$('[data-sx-wish-count]', root).forEach(function (el) { el.textContent = n + ' Parça'; });
      $$('[data-sx-wish-total]', root).forEach(function (el) { el.textContent = el.textContent.trim().charAt(0) === '₺' ? '₺' + money(total) : money(total) + ' TL'; });
      $$('[data-sx-wish-hv]', root).forEach(function (el) { el.textContent = '₺' + money(Math.round(total * hp / 100)); });
      $$('[data-sx-wish-empty]', root).forEach(function (el) { el.classList.toggle('hidden', n > 0); el.classList.toggle('flex', n === 0); });
      $$('[data-sx-wish-addall]', root).forEach(function (b) { b.disabled = n === 0; b.classList.toggle('opacity-50', n === 0); });
      var grid = shown.length ? shown[0].parentNode : (its[0] && its[0].parentNode); if (grid) grid.classList.toggle('hidden', n === 0);
      $$('[data-sx-wish-share]', root).forEach(function (a) {
        var names = shown.map(function (el) { var h = el.querySelector('h2,h3'); return h ? '- ' + h.textContent.trim() : ''; }).join('\n');
        a.href = waLink('Merhaba, istek listemdeki ürünler hakkında bilgi almak istiyorum:\n' + names);
      });
    });
  }
  document.addEventListener('fusya:wishlist', renderWishPage);
  document.addEventListener('DOMContentLoaded', renderWishPage);
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-sx-wish-remove],[data-sx-wish-addall]') : null;
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-sx-wish-remove')) {
      var it = t.closest('[data-sx-wish-item]'); if (it) toggleWish(it.getAttribute('data-sx-wish-item'));
    } else {
      var scope = t.closest('.sx-desktop,.sx-mobile') || document;
      var items = $$('[data-sx-wish-item]', scope).filter(function (el) { return !el.hidden && el.getAttribute('data-sx-available') === 'true'; })
        .map(function (el) { return { id: Number(el.getAttribute('data-sx-variant')), quantity: 1 }; });
      if (items.length) addToCart({ items: items }, t);
    }
  });

  /* ---------------------------------------------------------------- WhatsApp request forms */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('[data-sx-wa-form]')) return;
    e.preventDefault();
    var lines = [f.getAttribute('data-sx-wa-form')];
    $$('input,select,textarea', f).forEach(function (el) {
      if (!el.getAttribute('data-label') || el.type === 'submit' || el.type === 'button') return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.type === 'checkbox' && el.required) return;
      var v = el.tagName === 'SELECT' ? el.options[el.selectedIndex].text : el.value;
      if (el.type === 'radio' || el.type === 'checkbox') { var lb = el.closest('label'); v = lb ? lb.textContent.replace(/\s+/g, ' ').trim() : v; }
      if (v) lines.push(el.getAttribute('data-label') + ': ' + v);
    });
    window.open(waLink(lines.join('\n')), '_blank');
  });

  /* ---------------------------------------------------------------- init */
  document.addEventListener('DOMContentLoaded', function () {
    paintWish();
    try { if (!localStorage.getItem('fusyaCookie')) { var cb = $('[data-cookie-banner]'); if (cb) cb.removeAttribute('hidden'); } } catch (x) {}
  });
  if (document.readyState !== 'loading') paintWish();
  window.Fusya = F;
})();
